import { useMemo } from 'react';
import PropTypes from 'prop-types';

import { noop } from 'utils';
import { ArrowRightIcon } from 'icons';

import styles from './button.module.scss';

export const Button = ({
	children,
	wrapper: Wrapper = 'button',
	size = 'md',
	color = 'primary',
	type = 'default',
	hover = true,
	onClick = noop,
	...props
}) => {
	const wrapperClassName = useMemo(
		() =>
			[
				styles.wrapper,
				styles[size],
				styles[type],
				styles[color],
				hover ? styles.hover : '',
			].join(' '),
		[size, type, color, hover]
	);

	return (
		<Wrapper className={wrapperClassName} onClick={onClick} {...props}>
			<span className={styles.text}>{children}</span>
			{type === 'default' && (
				<span className={styles.icon}>
					<ArrowRightIcon className={styles.svg} />
				</span>
			)}
		</Wrapper>
	);
};

Button.propTypes = {
	hover: PropTypes.bool,
	onClick: PropTypes.func,
	color: PropTypes.oneOf([
		'primary',
		'secondary',
		'tertiary',
		'quaternary',
		'white',
		'warning',
	]),
	size: PropTypes.oneOf(['sm', 'md', 'lg']),
	type: PropTypes.oneOf(['default', 'minimal', 'rounded', 'outline']),
	wrapper: PropTypes.elementType,
};
